import { MINIO_S3_FUNCTIONS, AWS_S3_CLASS } from "neuron-file-server";
// import { getAwsConfig } from "neuron-apollo-common";
import { watchEffect } from "vue";
import store from "../store/index";

const IS_MINIO_S3 = process.env.VUE_APP_UPLOAD_SERVICE === "MINIO_S3";
// if (!store.state.AWS_CONFIG.S3CONFIG) {
//   const res = getAwsConfig();
//   store.dispatch("updateAwsConfigItem", {
//     key: "S3CONFIG",
//     val: res.S3CONFIG,
//   });
// }
// 新的
watchEffect(() => {
  console.log("store.state", store.state?.app?.token);
  if (store.state?.app?.token) {
    const obj = {
      token: store.state.app.token,
    };
    store.dispatch("updateAwsConfigItem", {
      key: "S3CONFIG",
      val: {
        ...obj,
      },
    });
    const S3CONFIG = { ...obj };
    const AWS_S3_FUNCTIONS = new AWS_S3_CLASS(S3CONFIG);
    window.AWS_S3_FUNCTIONS = IS_MINIO_S3
      ? MINIO_S3_FUNCTIONS
      : AWS_S3_FUNCTIONS;
  }
});
const { S3CONFIG } = store.state.AWS_CONFIG;
const AWS_S3_FUNCTIONS = new AWS_S3_CLASS({ ...S3CONFIG, token: "" });
window.AWS_S3_FUNCTIONS = IS_MINIO_S3 ? MINIO_S3_FUNCTIONS : AWS_S3_FUNCTIONS;
export default IS_MINIO_S3 ? MINIO_S3_FUNCTIONS : AWS_S3_FUNCTIONS;
